import CoinFlipWizardVirtualContainer from '../../components/coin-flip-wizard-virtual/CoinFlipWizardVirtual';

export const VirtualHome = () => <CoinFlipWizardVirtualContainer />;
